<button (click)="showGraphs()">Display Graphs</button>

<div *ngFor="let graph of graphs">
    <div id='{{graph.id}}'></div>
</div>